import { myStack as types } from '../actions/actiontypes'

const initState = {
  ongoing: [],
  stacks: {},
  delete: {},
  errors: {},
  mode: 'view',
  currentStack: {},
  currentSite: '',
  workProgress: '',
  workResult: [],

  createOngoing: 'initial',
  stack: null,
  error: null,
}

function addToOngoing(state, action) {
  return [
    ...state,
    {
      id: action.id,
      what: action.what,
    },
  ]
}

function removeFromOngoing(state, action) {
  return state.filter((o) => o.id != action.id)
}

function addToDeleted(state, action) {
  return Object.assign({}, state, {
    [action.id]: 'deleted',
  })
}

function addToStack(state, action) {
  return Object.assign({}, state, {
    [action.id]: action.stacks,
  })
}

function removeFromStack(state, action) {
  let { [action.id]: omit, ...res } = state
  return res
}

function addToError(state, action) {
  if (action.id) {
    return Object.assign({}, state, {
      [action.id]: action.error,
    })
  } else {
    return Object.assign({}, state, {
      create: action.error,
    })
  }
}

function addToRestoringStack(state, action) {
  return Object.assign({}, state, action.stack)
}

function updatePercentage(state, action) {
  return Object.assign({}, state, { percentage: action.percentage })
}

export function myStackReducer(state = initState, action) {
  switch (action.type) {
    case 'STORE_RESET':
      return {
        ...initState,
      }
    case types.CLEAR:
      return {
        ...state,
        createOngoing: 'initial',
        error: null,
        stack: null,
      }
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
        errors: {},
      }
    case types.CREATE:
      return {
        ...state,
        createOngoing: 'saving',
      }
    case types.CREATE_RESPONSE:
      return {
        ...state,
        createOngoing: 'saved',
        stack: action.stack,
      }
    case types.CREATE_FAIL:
      return {
        ...state,
        createOngoing: 'error',
        error: action.error,
        errors: addToError(state.error, action),
      }
    case types.GET:
    case types.SAVE:
    case types.DELETE:
    case types.COPY:
      return {
        ...state,
        ongoing: addToOngoing(state.ongoing, action),
      }
    case types.RESPONSE:
    case types.SAVE_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        stacks: addToStack(state.stacks, action),
        mode: 'view',
      }
    case types.DELETE_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        stacks: removeFromStack(state.stacks, action),
        delete: addToDeleted(state.delete, action),
      }
    case types.GET_FAIL:
    case types.SAVE_FAIL:
    case types.DELETE_FAIL:
      return {
        ...state,
        createOngoing: 'initial',
        ongoing: removeFromOngoing(state.ongoing, action),
        errors: addToError(state.error, action),
      }
    case types.COPY_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
      }
    case types.COPY_FAILED:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        error: action.error,
      }
    case types.SET_MODE:
      return {
        ...state,
        mode: action.mode,
      }
    case types.WORK:
      return {
        ...state,
        ongoing: addToOngoing(state.ongoing, action),
        currentStack: addToRestoringStack(state.currentStack, action),
        workProgress: updatePercentage(state.workProgress, action),
        currentSite: action.site,
      }
    case types.WORK_RESPONSE:
      return {
        ...state,
        ongoing: removeFromOngoing(state.ongoing, action),
        currentStack: {},
        workProgress: updatePercentage(state.workProgress, action),
        workResult: [...state.workResult, action.result],
        currentSite: '',
      }
    case types.CLEAR_WORK:
      return {
        ...state,
        ongoing: [],
        currentStack: {},
        workProgress: '',
        workResult: [],
        currentSite: '',
      }
    default:
      return state
  }
}
